export default "__VITE_ASSET__BkbPX2AT__"